import { useState } from "react";

import i18next from "i18next";

import { normalizePrice } from "../../../utils";

import ModalComponent from "../Modal";
import { Block, Buttons, Note, Prices } from "./style";

/**
 * «Цена изменилась»: бек (оригинал авиа-цены поставщика) сообщил, что бронь подорожала/подешевела.
 * Согласен → onAgree (update-price на беке), не согласен → onDisagree (обратно в поиск).
 * data: { old_price, new_price, currency, error_desc?, moved_again? }
 * variant="prebook" — та же модалка при выборе рейса из выдачи (перепоиск на prebook): тексты «с момента поиска»,
 * согласие = повторный prebook с новым rec_id.
 */
const PriceChangedModalComponent = ({ data, onAgree, onDisagree, variant = "order" }) => {
  const { t } = i18next;
  const key = name => (variant === "prebook" ? `price_changed_prebook_${name}` : `price_changed_${name}`);
  const [isLoading, setIsLoading] = useState(false);

  if (!data) return null;

  const { old_price, new_price, currency, moved_again, error_desc } = data;
  const isUp = Number(new_price) > Number(old_price);

  const handleAgree = () => {
    if (isLoading) return;
    setIsLoading(true);
    Promise.resolve(onAgree()).finally(() => setIsLoading(false));
  };

  return (
    <ModalComponent active onClose={onDisagree} flexCenter maxWidth={560} title={t("price_changed_title")}>
      <Block>
        <p>{t(key(isUp ? "text_up" : "text_down"))}</p>

        <Prices>
          <div className="row">
            <span>{t("price_changed_old")}</span>
            <span className="old">
              {normalizePrice(old_price)} {currency}
            </span>
          </div>
          <div className="row">
            <span>{t("price_changed_new")}</span>
            <span className="new">
              {normalizePrice(new_price)} {currency}
            </span>
          </div>
        </Prices>

        {moved_again && <Note>{t("price_changed_moved_again")}</Note>}
        {error_desc && <Note>{error_desc}</Note>}

        <p>{t(key("question"))}</p>

        <Buttons>
          <button type="button" className="agree" onClick={handleAgree} disabled={isLoading}>
            {isLoading ? t("price_changed_loading") : t("price_changed_agree")}
          </button>
          <button type="button" className="disagree" onClick={onDisagree} disabled={isLoading}>
            {t(key("disagree"))}
          </button>
        </Buttons>
      </Block>
    </ModalComponent>
  );
};

export default PriceChangedModalComponent;
